import React from 'react';
import { FormattedMessage, type MessageDescriptor } from 'react-intl-next';

import Lozenge from '@atlaskit/lozenge';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { LightningIcon } from '@confluence/icons/entry-points/LightningIcon';

const iconStyles = xcss({
	height: '12px',
	width: '12px',
});

export type FeatureLozengeProps = {
	showIcon?: boolean;
	message: string | MessageDescriptor;
	testId?: string;
};

export const FeatureLozenge = ({ showIcon = false, message, testId }: FeatureLozengeProps) => (
	<Lozenge
		testId={testId ?? 'feature-lozenge'}
		style={{
			// Since Lozenge doesn’t support xcss at the moment, the style prop is the only way to apply style overrides.
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
			backgroundColor: token('color.background.accent.teal.subtler'),
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
			color: token('color.text.accent.teal'),
		}}
	>
		<Inline space="space.050">
			{showIcon && (
				<Box xcss={iconStyles}>
					<LightningIcon label="" />
				</Box>
			)}
			{typeof message === 'string' ? message : <FormattedMessage {...message} />}
		</Inline>
	</Lozenge>
);
